import { RaceEntryEventType } from '../../../enums/raceEntry';

import { getSubmissionWindowFromDates } from '../../VirtualEvent/selectors';
import {
  getDaysToDate,
  isEventPassed as hasEventPassed,
} from '../../../utils/dates';

import { formatDateLong, formatDateRangeLong } from '../../../utils/formats';

const getDateHeadingString = (
  startDate,
  isLive,
  daysToGo,
  isBefore,
  isAfter,
) => {
  const isRaceToday = daysToGo === 0;

  let dateHeading;
  if (isLive) {
    dateHeading = 'Under way';
  } else if (isRaceToday && !isLive) {
    dateHeading = 'Today';
  } else if (isBefore) {
    const timeToText = daysToGo === 1 ? 'day to go' : 'days to go';
    dateHeading = `${daysToGo} ${timeToText}`;
  } else if (isAfter) {
    const raceYear = new Date(startDate).getFullYear();
    dateHeading = raceYear;
  }
  return dateHeading;
};

const getDateText = ({ isBefore, start, end }) => {
  if (isBefore && end) {
    return formatDateRangeLong(start, end, false);
  }
  if (isBefore && !end) {
    return formatDateLong(start);
  }
  return null;
};

// fetches time state given individual fields
export const getEventTimeStateAux = ({
  isVirtual,
  submissionStartDate,
  submissionEndDate,
  raceEntryStartDate,
}) => {
  if (isVirtual && submissionStartDate && submissionEndDate) {
    const {
      stage,
      isAfter,
      isBefore,
      isLive,
      start,
      end,
    } = getSubmissionWindowFromDates(submissionStartDate, submissionEndDate);
    const daysToGo = getDaysToDate(submissionStartDate);
    const dateHeading = getDateHeadingString(
      submissionStartDate,
      isLive,
      daysToGo,
      isBefore,
      isAfter,
    );

    const dateText = getDateText({ isBefore, start, end });

    return {
      stage,
      isAfter,
      isBefore,
      isLive,
      start,
      end,
      dateHeading,
      dateText,
    };
  }
  const start = raceEntryStartDate;
  const isAfter = hasEventPassed(start);
  const isBefore = !isAfter;
  const isLive = false;
  const stage = (isBefore && 'before') || (isAfter && 'after') || null;
  const daysToGo = getDaysToDate(raceEntryStartDate);
  const dateHeading = getDateHeadingString(
    start,
    isLive,
    daysToGo,
    isBefore,
    isAfter,
  );

  const dateText = getDateText({ isBefore, start });

  return {
    stage,
    isAfter,
    isBefore,
    isLive,
    start,
    dateHeading,
    dateText,
  };
};

// fetches time state given individual fields given raceEntry
export const getEventTimeState = (raceEntry) => {
  const isVirtual =
    raceEntry?.eventSummary?.raceType === RaceEntryEventType.VIRTUAL;
  const submissionStartDate =
    raceEntry?.eventSummary?.submissionWindow?.startDate;
  const submissionEndDate = raceEntry?.eventSummary?.submissionWindow?.endDate;
  const raceEntryStartDate = raceEntry?.eventSummary?.raceStartDate;

  return getEventTimeStateAux({
    isVirtual,
    submissionStartDate,
    submissionEndDate,
    raceEntryStartDate,
  });
};

export const getDateTextToDisplay = (raceEntry) => {
  const submissionStartDate =
    raceEntry?.eventSummary?.submissionWindow?.startDate;
  const submissionEndDate = raceEntry?.eventSummary?.submissionWindow?.endDate;

  const { start, end } = getSubmissionWindowFromDates(
    submissionStartDate,
    submissionEndDate,
  );
  if (start && end) {
    return formatDateRangeLong(start, end, false);
  }
  if (start) {
    return formatDateLong(start);
  }
  return null;
};
